import { useDeviceClass } from '../../../shared/hooks/useDeviceClass';
import { CamerasDesktopView } from '../views/CamerasDesktopView';
import { CamerasMobileView } from '../views/CamerasMobileView';
import { CamerasTabletView } from '../views/CamerasTabletView';

export function CamerasPage() {
  const device = useDeviceClass();
  if (device === 'mobile') return <CamerasMobileView />;
  if (device === 'tablet') return <CamerasTabletView />;
  return <CamerasDesktopView />;
}
